import React, { useEffect, useState } from 'react'
import { styles } from './styles'
import { Storage } from '@aws-amplify/storage'
import birdAvatar from '../../assets/images/bird-avatar.png'
import Auth from '@aws-amplify/auth'
import CircularProgress from '@material-ui/core/CircularProgress'
import { ENDPOINTS, baseURL } from '../../constants'
import axios from './../../axios'
import { useAppState } from '../../appState'
import { withTranslation } from 'react-i18next'
import { TFunction } from 'i18next'
import ImageDialog from '../imageAdjust/adjustImageDialog'
import profileActiveIcon from '../../assets/images/profile-active.svg'
import plusIcon from '../../assets/images/plusIcon.svg'
import { v4 as uuidv4 } from 'uuid'

export const Modal = ({ src, alt, onClose }) => {
  const classes = styles()
  return (
    <div className={classes.modal}>
      <span className={classes.close} onClick={onClose}>
        &times;
      </span>
      <img className={classes.modalContent} src={src} alt={alt} />
    </div>
  )
}
interface UploadAvatarProps {
  t: TFunction
  inputId?: string
  circleInputId?: string
  shoppingUserProfile?: any
  updateShoppingProfile?: any
  canEdit?: boolean
  hideSymbol?: boolean
}

const CHRUploadAvatar = ({
  t,
  inputId = '',
  circleInputId = '',
  shoppingUserProfile,
  updateShoppingProfile,
  canEdit = true,
  hideSymbol = false,
}: UploadAvatarProps) => {
  const [appState, dispatch] = useAppState()
  const [open, setOpen] = useState(false)
  const [enlargeImage, setEnlargeImage] = useState(false)
  const showModal = () => setEnlargeImage(true)
  const [selectedImage, setSelectedImage] = useState(null)

  const isShoppingBoard = Boolean(shoppingUserProfile)
  const classes = styles()

  const [uploadImage, setUploadImage] = useState({
    imageKey: '',
    imageUrl: '',
    isUploadImageLoading: true,
  })

  const cropCallback = async (url: string) => {
    try {
      const base64Data = Buffer.from(
        url.replace(/^data:image\/\w+;base64,/, ''),
        'base64'
      )
      setOpen(false)
      setUploadImage({ isUploadImageLoading: true })

      const ext = selectedImage.name.split('.').pop()
      const randomName = `${uuidv4()}.${ext}`
      const result = await Storage.put(randomName, base64Data, {
        level: 'public',
        contentType: 'image/gif, image/jpeg, image/png',
      })

      if (result?.key) {
        const reqBody = { image: result.key }
        await axios.patch(
          `${baseURL}/${ENDPOINTS.user.replace(':id', appState.userId)}`,
          reqBody
        )
        const currentUserInfo = await Auth.currentCredentials()

        const url = `https://${process.env.GATSBY_S3_BUCKET_NAME}.s3.us-east-2.amazonaws.com/public/${result.key}`

        if (isShoppingBoard) {
          const shoppingUserProfileUpdate = {
            email: '',
            username: shoppingUserProfile.username,
            fullName: shoppingUserProfile.fullName,
            shortBio: shoppingUserProfile.shortBio,
            imageKey: result.key,
            imageUrl: url,
          }

          updateShoppingProfile(shoppingUserProfileUpdate)
        }
        dispatch({
          type: 'UPDATE_USER_DATA',
          userProfile: {
            ...appState.userProfile,
            imageKey: result.key,
            imageUrl: url,
          },
        })

        setUploadImage({
          ...uploadImage,
          imageKey: result.key,
          imageUrl: url,
          isUploadImageLoading: false,
        })
      }
    } catch (error) {
      dispatch({
        type: 'UPDATE_USER_DATA',
        userProfile: {
          ...appState.userProfile,
          imageError: t('messages.uploadFailed'),
        },
      })
      setUploadImage({
        ...uploadImage,
        isUploadImageLoading: false,
      })
      setSelectedImage(null)
      onCancel()
    }
  }

  const onCancel = () => {
    setOpen(false)
  }

  const onUploadImage = async (event: any) => {
    const files = event.target.files
    if (files && files.length > 0 && event.target.files[0]) {
      setSelectedImage(event.target.files[0])
      setOpen(true)
    }
  }

  useEffect(() => {
    ;(async () => {
      if (isShoppingBoard) {
        const { imageUrl, imageKey } = shoppingUserProfile
        if (imageKey && !imageUrl) {
          const url = `https://${process.env.GATSBY_S3_BUCKET_NAME}.s3.us-east-2.amazonaws.com/public/${imageKey}`
          setUploadImage({
            imageKey: imageKey,
            imageUrl: url,
            isUploadImageLoading: false,
          })
        } else {
          setUploadImage({
            imageKey: imageKey || '',
            imageUrl: imageUrl || '',
            isUploadImageLoading: false,
          })
        }
      } else {
        const { imageUrl, imageKey } = appState.userProfile
        setUploadImage({
          imageKey: imageKey || '',
          imageUrl: imageUrl || '',
          isUploadImageLoading: false,
        })
      }
    })()
  }, [appState.userProfile])

  return (
    <>
      <ImageDialog
        cropCallback={cropCallback}
        openStatus={open}
        selectedImage={selectedImage}
        onCancel={onCancel}
      />
      <span
        className={`${classes.uploadPictureAvatar} ${
          uploadImage.imageUrl ? classes.uploadedPictureAvatar : ''
        }`}
      >
        {uploadImage.isUploadImageLoading ? (
          <span className={classes.spinner}>
            <CircularProgress color="secondary" />
          </span>
        ) : (
          <>
            {uploadImage.imageUrl && (
              <img
                onClick={canEdit ? null : showModal}
                src={uploadImage.imageUrl}
                alt={t('shared.chirpyest')}
                className={classes.userAvatar}
              />
            )}
            {!uploadImage.imageUrl && (
              <div className={classes.profileMedia}>
                <img
                  src={birdAvatar}
                  alt={t('shared.chirpyest')}
                  className={classes.userAvatar}
                />
              </div>
            )}
          </>
        )}
      </span>
      {enlargeImage && (
        <Modal
          src={uploadImage.imageUrl}
          alt={t('shared.chirpyest')}
          onClose={() => setEnlargeImage(false)}
        />
      )}
      {inputId && (
        <input
          id={inputId}
          type="file"
          accept="image/gif, image/jpeg, image/png"
          onChange={e => onUploadImage(e)}
          className={classes.uploadInput}
        />
      )}
      <input
        id={inputId}
        type="file"
        accept="image/gif, image/jpeg, image/png"
        onChange={e => onUploadImage(e)}
        className={classes.uploadInput}
      />
      {circleInputId && (
        <input
          id={circleInputId}
          type="file"
          accept="image/gif, image/jpeg, image/png"
          onChange={e => onUploadImage(e)}
          className={classes.uploadInput}
        />
      )}
      {!hideSymbol && shoppingUserProfile?.isPro && uploadImage.imageUrl && (
        <div className={classes.profileActive}>
          <img src={profileActiveIcon} alt={t('shared.chirpyest')} />
        </div>
      )}
      {inputId &&
        !uploadImage.imageUrl &&
        !uploadImage.isUploadImageLoading &&
        canEdit && (
          <span className={classes.uploadImage}>
            <img src={plusIcon} alt="plus-icon" />
          </span>
        )}
    </>
  )
}

export default withTranslation()(CHRUploadAvatar)
